import { Wrapper, H1 } from './styles';

export const AppSlogan = () => (
	<Wrapper>
		<H1>Tracking Swimmer's<br />Progress Made Easy</H1>
	</Wrapper>
)